<button
  mat-raised-button
  [ngClass]="{
    'full-width': fullWidth,
    'medium-width': mediumWidth
  }"
  class="app-button"
  [color]="color"
  [disabled]="disabled"
  [type]="type"
  (click)="buttonClick()">
  <ng-content></ng-content>
</button>
